import { useEffect, useState } from 'react';
import api from 'src/services/api';

export default function useFetch(url) {
  const [data, setData] = useState(null);
  const [isError, setIsError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('Falha ao realizar busca.');
  const [isLoading, setIsLoading] = useState(true);
  const [refetch, setRefetch] = useState(false);

  useEffect(() => {
    async function fetchFunction() {
      try {
        setIsLoading(true);
        setIsError(false);

        const response = await api.get(url);

        setData(response?.data);
      } catch (error) {
        setIsError(true);

        if (error?.message) {
          setErrorMessage(error.message);
        }
      } finally {
        setIsLoading(false);
      }
    }

    if (typeof url === 'string') {
      fetchFunction();
    } else {
      setIsLoading(false);
    }
  }, [url, refetch]);

  const refetchRequest = () => {
    setRefetch((currentRefetch) => !currentRefetch);
  };

  const result = [data, isLoading, isError, errorMessage, refetchRequest];

  result.isLoading = isLoading;
  result.isError = isError;
  result.data = data;
  result.errorMessage = errorMessage;
  result.refetch = refetchRequest;

  return result;
}
